import SettingsEthernetIcon from '@material-ui/icons/SettingsEthernet'
import { ProductFacadeList } from './ProductFacadeList'
import { ROLES } from 'utils/user'

export default {
  list: ProductFacadeList,
  icon: SettingsEthernetIcon,
  permissions: [ROLES.ROLE_ADMIN],
}
